export const SET_PAGE = 'SET_PAGE'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES'
export const REQUEST_DATA_SUCCESS = 'REQUEST_DATA_SUCCESS'
